export default "__VITE_ASSET__CTPuaIwX__"